/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *|
 *| IBM Cognos Products: Dashboard
 *|
 *| (C) Copyright IBM Corp. 2021
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define(function() {
	'use strict';
	class MultipleDialCategoryLabel {
		get config(){
			return {
				'disablePan':true,
				'isRecommendable':false,
				'slots':{
					'category':{
						'optional':false
					},
					'label':{
						'optional':true
					}
				},
				'properties':{
					'format.compact':{
						'active':false
					},
					'legendPosition':{
						'active':false
					},
					'legend.display':{
						'active':false
					}
				},
				'supportsMaintainAxisScale':true
			};
		}
	}
	return MultipleDialCategoryLabel;
});
